import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";
import useScrollReveal from "@/hooks/useScrollReveal";
import useSeo from "@/hooks/useSeo";
import useCodeInjection from "@/hooks/useCodeInjection";
import useSiteTracking from "@/hooks/useSiteTracking";

// Public site layout route. Renders the matched page via <Outlet/> and runs
// the public-only concerns: scroll reveal, dynamic SEO head, code injection,
// and site-wide tracking scripts.
export default function Layout() {
  useScrollReveal();
  useSeo();
  useCodeInjection();
  useSiteTracking();
  return (
    <div className="min-h-screen bg-cream text-ink_soft">
      <Navbar />
      <main data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
